import { render, staticRenderFns } from "./ConfirmFACoalManager.vue?vue&type=template&id=2b4a41e7&"
import script from "./ConfirmFACoalManager.vue?vue&type=script&lang=js&"
export * from "./ConfirmFACoalManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports